import { Controller } from "stimulus";

export default class extends Controller {
  static get targets() {
    return ["wrapper"];
  }
  initialize() {
    console.log("Flash message controller is working!");
  }
  close() {
    const wrapper = this.wrapperTarget;
    wrapper.classList.add("hidden");
  }
}
